import React from 'react';
import { manifestoLines } from '../mock';
import useReveal from '../hooks/useReveal';

const Manifesto = () => {
  const ref = useReveal();
  return (
    <section
      id="vision"
      ref={ref}
      className="relative py-16 md:py-20 [@media(max-height:500px)]:py-14 px-6 md:px-10 border-t border-white/5 overflow-hidden"
    >
      {/* Full-width background image + light overlays */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <img
          src="/mission-atlas.webp" srcSet="/mission-atlas-400w.webp 400w, /mission-atlas-800w.webp 800w, /mission-atlas.webp 2000w" sizes="(max-width: 640px) 400px, (max-width: 1024px) 800px, 2000px" loading="lazy" decoding="async"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[color:var(--obsidian)]/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[color:var(--obsidian)]/40 via-transparent to-[color:var(--obsidian)]/70" />
      </div>

      <div className="relative max-w-[1400px] mx-auto">
        {/* Headline split into upper-left + lower-right blocks */}
        <div className="relative grid md:grid-cols-2 gap-8 md:gap-16 min-h-[420px] md:min-h-[520px] [@media(max-height:500px)]:!min-h-[240px]">
          <div className="reveal md:col-start-1 md:row-start-1 self-start">
            <div className="inline-flex items-center rounded-full border border-white/10 bg-[color:var(--obsidian)]/70 backdrop-blur-md shadow-lg shadow-black/40 px-4 py-2 mb-4 [@media(max-height:500px)]:mb-2">
              <span className="font-mono text-[12px] md:text-[10.5px] tracking-[0.24em] uppercase text-[color:var(--green)]">
                &mdash; Our Mission & Values
              </span>
            </div>
            <h2 className="font-display text-[22px] md:text-[36px] [@media(max-height:500px)]:!text-[18px] leading-[1.1] text-[color:var(--parchment)] max-w-lg drop-shadow-[0_2px_10px_rgba(0,0,0,0.7)]">
              Professional estate liquidation that maximizes every estate&rsquo;s value
            </h2>
          </div>

          <div className="reveal md:col-start-2 md:row-start-2 self-end md:text-right md:justify-self-end">
            <p className="font-display text-[22px] md:text-[36px] [@media(max-height:500px)]:!text-[18px] leading-[1.1] text-[color:var(--parchment)] max-w-lg drop-shadow-[0_2px_10px_rgba(0,0,0,0.7)]">
              &mdash; while delivering <span className="text-[color:var(--green)]">transparency</span>, care, and peace of mind for our clients.
            </p>
          </div>
        </div>

        <div className="mt-14 [@media(max-height:500px)]:mt-8 grid md:grid-cols-4 [@media(max-height:500px)]:grid-cols-2 gap-0 border-t border-white/15 pt-10 [@media(max-height:500px)]:pt-6">
          {manifestoLines.map((m, i) => (
            <div key={m.k} className={`reveal pillar-col px-4 md:px-6 pb-4 [@media(max-height:500px)]:py-4 ${i === 0 ? 'pl-0' : ''}`} style={{ transitionDelay: `${i * 100}ms` }}>
              <div className="font-mono text-[12px] md:text-[10.5px] tracking-[0.24em] uppercase text-[color:var(--parchment)]/60">{m.k}</div>
              <div className="font-display text-[18px] md:text-[22px] [@media(max-height:500px)]:!text-[16px] leading-tight text-[color:var(--parchment)] mt-3 drop-shadow-[0_2px_8px_rgba(0,0,0,0.7)]">{m.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
